<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit Page</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="5"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editPage',
    components: {
        EditElement,
    },
    data() {
        return {
            pageId: null,
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Pages',
                    to: '/pages/all'
                }, {
                    text: 'Edit Page',
                    href: '#'
                }
            ]
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>